"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPath = exports.getPointsDistanceMeter = void 0;
exports.getPointsDistanceMeter = function (from, to) {
    return google.maps.geometry.spherical.computeDistanceBetween(new google.maps.LatLng(from.lat, from.lng), new google.maps.LatLng(to.lat, to.lng));
};
exports.getPath = function (from, to, mode) {
    if (mode === void 0) { mode = 'walking'; }
    return new Promise(function (resolve, reject) {
        var directionsService = new google.maps.DirectionsService();
        var getTravelMode = function (mode) {
            switch (mode) {
                case 'walking':
                    return google.maps.TravelMode.WALKING;
                case 'driving':
                    return google.maps.TravelMode.DRIVING;
                case 'transit':
                    return google.maps.TravelMode.TRANSIT;
            }
        };
        var request = {
            origin: from,
            destination: to,
            travelMode: getTravelMode(mode),
        };
        directionsService.route(request, function (result, status) {
            if (status === google.maps.DirectionsStatus.OK) {
                var path_1 = [];
                var legs = result.routes[0].legs;
                legs.map(function (it) {
                    it.steps.map(function (it2) {
                        it2.path.map(function (location) {
                            path_1.push({
                                lat: location.lat(),
                                lng: location.lng(),
                            });
                        });
                    });
                });
                var duration = Math.round((result.routes[0].legs[0].duration.value / 60) * 100) /
                    100;
                resolve({ path: path_1, duration: duration });
            }
            else {
                console.log(status);
                reject();
            }
        });
    });
};
